/**
 * UserDetailPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col } from 'components';
import {
  Button,
  Select,
  Tag,
  Descriptions as AntDescriptions,
  Table,
} from 'antd';
import {
  EditOutlined,
  CheckCircleOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons';
import Formatter from 'utils/Formatter';
import { stringToMoneyFormat } from 'utils';
import moment from 'moment';

import { JM_PAY_TYPE } from 'constants/JMPayConstant';

const SIGNUP_PATH = {
  MEMBER: '일반가입',
  NAVER: '네이버',
  GOOGLE: '구글',
  APPLE: '애플',
  KAKAO: '카카오',
  NONE: '비회원',
};
const ACCOUNT_STATUS = {
  ACTIVE: { label: '정상', color: 'green' },
  INACTIVE: { label: '비활성', color: 'orange' },
  DORMANT: { label: '휴먼', color: 'grey' },
  WITHDRAWN: { label: '탈퇴', color: 'red' },
};

const USER_SETTING = {
  location_consent: '위치정보 서비스 이용약관 동의',
  marketing_consent: '마케팅정보 수집 및 활용 동의',
  push_notification: '푸시알림',
  event_notification: '프로모션/이벤트 알림',
  terms_of_use: '이용약관 동의 여부',
  terms_of_privacy: '개인정보 수집 및 이용 동의 여부',
  terms_of_marketing: '마케팅 목적의 개인정보 수집 및 이용 동의 여부',
  terms_of_ad: '혜택 및 광고성 정보 수신 동의',
  terms_of_age: '만 14세 이하',
};

const PAYMENT_STATE = {
  PENDING: '결제 대기',
  COMPLETED: '결제 완료',
  CANCELLED: '결제 취소',
  FAILED: '결제 실패',
  REFUNDED: '환불 완료',
};

/**----------------------------------------
 * [Component] 관리자 > 유저상세: 프레젠터
 * ----------------------------------------
 */
const UserDetailPresenter = ({
  userData,
  currentUserId,
  manageType,
  jmpayData,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [isOpened, setIsOpened] = React.useState(false);
  const [modalType, setModalType] = React.useState('');
  const [memo, setMemo] = React.useState('');
  const [modalData, setModalData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [detailTab, setDetailTab] = React.useState('default');
  const [jmpayModal, setJmpayModal] = React.useState(null);
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <div>
      <Content maxWidth={'100%'} padding={0}>
        {/* === 모달 > 상세보기: start === */}
        <Row>
          {/* === 모달 > 상세보기: end === */}
          <Col x={24}>
            <Content maxWidth={'100%'} padding={'0px 0px 20px'}>
              <Title size={5} style={{ marginBottom: 5 }}>
                회원 주문 정보
              </Title>
              {userData ? (
                <AntDescriptions
                  bordered
                  column={2}
                  size="small"
                  labelStyle={styles.labelStyle}
                  contentStyle={styles.contentStyle}
                  style={styles.defaultStyle}
                  items={[
                    {
                      key: `order1`,
                      label: 'JM Pay 잔액',
                      children: (
                        <>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}
                          >
                            <p>{stringToMoneyFormat(userData?.jm_pay, 'P')}</p>
                            {/* <p>
                              <Button
                                size="small"
                                type="link"
                                style={{
                                  textDecoration: 'underline',
                                  padding: 0,
                                }}
                                onClick={() => setJmpayModal(true)}
                              >
                                상세보기
                              </Button>
                            </p> */}
                          </div>
                        </>
                      ),
                    },
                    {
                      key: `order2`,
                      label: '보유 포인트',
                      children: stringToMoneyFormat(userData?.totalPoint, 'P'),
                    },
                    {
                      key: `order3`,
                      label: '오더 주문',
                      children: (
                        <button
                          style={{
                            border: 'none',
                            background: 'none',
                            // color: '#1C6BFF',
                            // textDecoration: 'underline',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setIsOpened(!isOpened);
                            setModalType('ORDER');
                          }}
                        >
                          {stringToMoneyFormat(
                            userData?.orderHistory?.length,
                            '건'
                          )}
                        </button>
                      ),
                    },
                    {
                      key: `order4`,
                      label: '오더 총 결제금액',
                      children: stringToMoneyFormat(
                        userData?.totalOrderPrice,
                        '원'
                      ),
                    },
                    {
                      // TODO
                      key: `order5`,
                      label: '몰 주문',
                      children: stringToMoneyFormat(0, '건'),
                    },
                    {
                      // TODO
                      key: `order6`,
                      label: '몰 총 결제금액',
                      children: stringToMoneyFormat(0, '건'),
                    },
                  ]}
                />
              ) : null}
            </Content>

            {/* ===== JM Pay history: start ===== */}
            {manageType === 'JM_PAY' && (
              <Content maxWidth={'100%'} padding={'20px 0px 20px'}>
                <Title size={5} style={{ marginBottom: 5 }}>
                  JM페이 사용내역({jmpayData.length ?? 0})
                </Title>
                <Table
                  size="small"
                  className="boxShadow"
                  bordered
                  scroll={{ x: 800, y: 250 }}
                  style={styles.defaultStyle}
                  dataSource={jmpayData}
                  columns={[
                    {
                      title: '결제번호',
                      dataIndex: 'jm_pay_id',
                      width: 100,
                      align: 'center',
                    },
                    {
                      title: '결제일(시간)',
                      dataIndex: 'created_at',
                      width: 185,
                      align: 'center',
                      render: (value) =>
                        moment(value * 1000).format('YYYY-MM-DD (HH:mm:ss)'),
                      sorter: (a, b) => a.created_at - b.created_at,
                    },
                    {
                      title: '결제수단',
                      dataIndex: 'order_route',
                      width: 110,
                      align: 'center',
                      filters: [
                        { text: '포스', value: 'POS' },
                        { text: '키오스크', value: 'KIOSK' },
                        { text: '앱', value: 'APP' },
                      ],
                      onFilter: (value, record) =>
                        record.order_route.includes(value),
                    },
                    {
                      title: '사용금액',
                      dataIndex: 'price',
                      width: 130,
                      align: 'center',
                      render: (value) => stringToMoneyFormat(value),
                      sorter: (a, b) => a.price - b.price,
                    },
                    {
                      title: '분류',
                      dataIndex: 'type',
                      width: 100,
                      align: 'center',
                      render: (value) => (
                        <Tag color={JM_PAY_TYPE[value]?.color}>
                          {JM_PAY_TYPE[value]?.label}
                        </Tag>
                      ),
                      filters: Object.entries(JM_PAY_TYPE)
                        .map((v) => {
                          return {
                            text: v[1]?.label,
                            value: v[0],
                          };
                        })
                        .flat(),
                      onFilter: (value, record) => record.type.includes(value),
                    },
                    {
                      title: '결제후 잔액',
                      dataIndex: 'current_balance',
                      width: 120,
                      align: 'center',
                      render: (value) => stringToMoneyFormat(value ?? 0),
                      sorter: (a, b) => a.current_balance - b.current_balance,
                    },
                  ]}
                />
              </Content>
            )}
            {/* ===== JM Pay history: end ===== */}

            {/* === 회원정보: start === */}
            <Title size={5} style={{ marginBottom: 5 }}>
              회원 정보
            </Title>
            {userData ? (
              <AntDescriptions
                bordered
                column={2}
                size="small"
                labelStyle={styles.labelStyle}
                contentStyle={styles.contentStyle}
                style={styles.defaultStyle}
                items={[
                  {
                    key: '1',
                    label: '회원번호',
                    children: `${userData?.user_id}`,
                  },
                  {
                    key: '2',
                    label: '회원명',
                    children: `${userData?.user_name ?? '-'}`,
                  },
                  {
                    key: '3',
                    label: '회원 아이디',
                    children: `${userData?.user_account ?? '-'}`,
                  },
                  {
                    key: '4',
                    label: '계정상태',
                    children: (
                      <Select
                        style={{ width: '100%' }}
                        value={userData?.account_status}
                        options={Object.entries(ACCOUNT_STATUS)
                          .filter(([key]) => key !== 'WITHDRAWN')
                          .map(([key, value]) => ({
                            label: value?.label,
                            value: key,
                          }))}
                        // onChange={(v) => changeAccountStatus(v)}
                      />
                    ),
                  },
                  {
                    key: '5',
                    label: '연락처',
                    children: `${userData?.user_phone ?? '-'}`,
                  },
                  {
                    key: '6',
                    label: '이메일',
                    children: `${userData?.user_email ?? '-'}`,
                  },
                  {
                    key: '7',
                    label: '성별',
                    children: `${userData?.user_gender === 'M' ? '남' : '여'}`,
                  },
                  {
                    key: '8',
                    label: '생년월일',
                    children: `${Formatter.unixToDate(
                      userData?.user_birthday,
                      'YYYY.MM.DD'
                    )}`,
                  },
                  {
                    key: '18',
                    label: '회원등급',
                    children: `${userData?.grade?.grade_name ?? '-'}`,
                  },
                  {
                    key: '19',
                    label: '',
                    children: ``,
                  },
                  {
                    key: '9',
                    label: '주소',
                    children: `${userData?.user_address ?? '-'}\n${
                      userData?.user_address_detail ?? ''
                    }`,
                    span: 2,
                  },
                  {
                    key: '10',
                    label: '닉네임',
                    children: `${userData?.user_nick_name ?? '-'}`,
                  },
                  {
                    key: '11',
                    label: '멤버십 번호',
                    children: `${
                      Formatter.membership(userData?.membership_code) ?? '-'
                    }`,
                  },
                  {
                    key: '12',
                    label: '가입일',
                    children: `${Formatter.unixToDate(
                      userData?.created_at,
                      'YYYY.MM.DD HH:mm:ss'
                    )}`,
                  },
                  {
                    key: '13',
                    label: '최근 접속일',
                    children: `${Formatter.unixToDate(
                      userData?.access_time,
                      'YYYY.MM.DD HH:mm:ss'
                    )}`,
                  },
                  {
                    key: '14',
                    label: '가입경로',
                    children: `${
                      userData?.social_type
                        ? SIGNUP_PATH[userData?.social_type]
                        : userData?.user_name
                        ? SIGNUP_PATH['MEMBER']
                        : SIGNUP_PATH['NONE']
                    }`,
                  },
                  {
                    key: '15',
                    label: '보유쿠폰',
                    children: (
                      <p>
                        <button
                          style={{
                            border: 'none',
                            background: 'none',
                            color: '#1C6BFF',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setIsOpened(!isOpened);
                            setModalType('COUPON');
                          }}
                        >
                          {stringToMoneyFormat(
                            userData?.couponStorage?.useable?.length,
                            '개'
                          )}
                        </button>
                      </p>
                    ),
                  },
                  {
                    key: '16',
                    label: '회원설정',
                    children: (
                      <div>
                        {Object.entries(userData?.user_setting || {}) // user_setting이 없으면 빈 객체 처리
                          .map(([key, value], index) => {
                            if (!USER_SETTING[key]) return null; // 조건이 충족되지 않으면 null 반환

                            return (
                              <p
                                style={{
                                  // margin: '8px 0px',
                                  margin: 0,
                                  padding: '5px 0',
                                  textAlign: 'left',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  borderTop:
                                    index > 0 ? '1px solid #f1f1f1' : 'none',
                                }}
                              >
                                <p style={{ margin: 0 }}>
                                  {USER_SETTING[key]}:
                                </p>{' '}
                                <p style={{ margin: 0 }}>
                                  {value ? (
                                    <Tag
                                      icon={<CheckCircleOutlined />}
                                      color="success"
                                    >
                                      동의
                                    </Tag>
                                  ) : (
                                    <Tag
                                      icon={<MinusCircleOutlined />}
                                      color="default"
                                    >
                                      미동의
                                    </Tag>
                                  )}
                                </p>
                                {/* <p>{value ? '동의' : '미동의'}</p> */}
                              </p>
                            );
                          })}
                      </div>
                    ),
                    span: 2,
                  },
                  {
                    key: '17',
                    label: (
                      <p>
                        메모{' '}
                        <Button
                          size="small"
                          style={{
                            // border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                            padding: '0 6px',
                            marginLeft: 3,
                            height: 19,
                          }}
                          onClick={() => {
                            setIsOpened(!isOpened);
                            setModalType('MEMO');
                          }}
                        >
                          <EditOutlined style={{ fontSize: '0.85em' }} />
                        </Button>
                      </p>
                    ),
                    children: (
                      <p
                        style={{
                          whiteSpace: 'pre-line',
                          textAlign: 'left',
                        }}
                      >
                        {userData?.memo}
                      </p>
                    ),
                    span: 2,
                  },
                ]}
              />
            ) : null}
          </Col>
          {/* === 회원정보: end === */}
        </Row>
      </Content>
    </div>
  );
};

/*  */
const styles = {
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 20,
  },
  button: {
    width: 80,
    height: 40,
    fontSize: 15,
    fontWeight: 600,
    margin: '0px 4px',
  },
  form: {
    input: {
      large: {
        width: 175,
        marginRight: 8,
      },
      medium: {
        width: 100,
        marginRight: 8,
      },
    },
    button: {
      marginRight: 8,
    },
    date: {
      width: 150,
    },
    text: {
      fontSize: 13,
      fontWeight: 400,
    },
  },

  couponLayout: {
    width: '100%',
    backgroundColor: '#f4f4f4',
    borderLeft: '20px solid #ddd',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 20,
    paddingLeft: 20,
    position: 'relative',
    top: 0,
    left: 0,
  },
  couponTitle: {
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 16,
  },
  couponStatus: {
    color: 'var(--black-color)',
    fontSize: 16,
    lineHeight: 1.75,
  },
  couponDate: {
    fontSize: 14,
    fontWeight: 700,
    color: 'var(--dark-gray-color)',
  },

  labelStyle: {
    // width: 155,
    width: '18%',
    color: '#111',
    fontWeight: '500',
    background: '#f4f4f4',
  },
  contentStyle: { width: '32%' },
  defaultStyle: {
    borderTop: '2px solid #d1d1d1',
    borderRadius: 5,
    marginTop: 5,
  },
};
/*  */
export default UserDetailPresenter;
